import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { ROUTES } from 'Constants/routes';

const ProtectedRoute = ({ permission, children }) => {
    const user = useSelector(state => state.auth.user || {});
    const permissions = user.permissions || [];
    const access = user.access;
    if (access === 'Admin') {
        return children;
    }
    if (!permissions.includes(permission)) {
        return <Navigate to={ROUTES.FORBIDDEN_403} />;
    }
    return children;
};

export default ProtectedRoute; 